import { GlButton } from '@gitlab/ui';
import { __ } from '~/locale';
export default {
    name: 'MrCollapsibleExtension',
    components: {
        GlButton
    },
    props: {
        title: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isCollapsed: true
        };
    },
    computed: {
        arrowIconName () {
            return this.isCollapsed ? 'chevron-right' : 'chevron-down';
        },
        ariaLabel () {
            return this.isCollapsed ? __('Expand') : __('Collapse');
        }
    },
    methods: {
        toggleCollapsed () {
            this.isCollapsed = !this.isCollapsed;
        }
    }
};
